import { IconButton, ICON_SIZE } from "@shared/components/icon-button";
import AngleIcon from "@svg/angle-icon";
import classNames from "classnames";
import { FC, Dispatch, SetStateAction } from "react";
import LockIcon from "@svg/lock-icon";
import { LESSON_STEP_TYPE, StepPreviewItem } from "@types";
import HeadlineItem from "./headline-item";
import Accordion from "legacy/elements/accordion";

interface Props {
  stateIndex: number;
  accordionsStatus: boolean[];
  setAccordionsStatus: Dispatch<SetStateAction<boolean[]>>;
  courseTitle: string;
  stepIndexAccordion: number;
  courseContentItems: any[];
  allSteps: StepPreviewItem | undefined;
}

const RelatedFiles: FC<Props> = ({
  stateIndex,
  setAccordionsStatus,
  accordionsStatus,
  courseTitle,
  courseContentItems,
  stepIndexAccordion,
  allSteps,
}) => {
  return (
    <Accordion
      key={stateIndex}
      className={(isOpen) =>
        classNames(
          "h-auto py-2.5   rounded-b-12 md:py-3  pl-2  pr-5    bg-fds-secondary border-t border-fds-default",
          isOpen && "rounded-b-none border-b"
        )
      }
      title="فایل‌های همراه"
      titleClassName={classNames(
        "title-md-demibold text-fds-primary text-ellipsis whitespace-nowrap overflow-hidden"
      )}
      contentClassName=""
      openAccordion={(isOpen) =>
        setAccordionsStatus((prev) =>
          prev.map((accordionStatus, i) =>
            i === stateIndex ? isOpen : accordionStatus
          )
        )
      }
      iconComponent={(isOpen) => (
        <IconButton
          size={ICON_SIZE.MEDIUM}
          iconClassName={classNames(
            "text-fds-icon-secondary basis-4 mdx:basis-4 grow-0 shrink-0  transition-all duration-300 ease-linear w-4     h-4    ",
            isOpen ? "rotate-180" : "rotate-0"
          )}
          aria-label="باز و بستن محتوا"
          icon={<AngleIcon />}
        />
      )}
      open={accordionsStatus[stateIndex]}
    >
      <div className="py-2.5   relative ">
        {courseContentItems.map((step, i) => {
          const itemProps = {
            isFree: false,
            openForGuest: false,
            duration: "",
            iconComponent: LockIcon,
            subtitle: courseTitle,
            title: step,
            stepIndex: stepIndexAccordion,
            allSteps,
            courseType: LESSON_STEP_TYPE.EXAM,
          };

          return <HeadlineItem key={i} {...itemProps} id={i} />;
        })}
      </div>
    </Accordion>
  );
};

export default RelatedFiles;
